import Resource from '@/services/resources/common';

export default class DocumentValidatorResource extends Resource {
  constructor(entrypoint = '/document_validators', alias = 'DocumentValidator') {
    super(entrypoint, alias);
  }
}
